export default __webpack_public_path__ + "assets/icon-unidentified-collection.afd0e6e4.webp";